import { Routes } from '@angular/router';
import { RoleGuard } from '@guards/role.guard';

const purchaseOrderModule = () => import('./purchase-order.module').then((m) => m.PurchaseOrderModule);

export const purchaseOrderRoutes: Routes = [
  {
    path: 'purchase-order',
    canActivateChild: [RoleGuard],
    loadChildren: purchaseOrderModule,
    data: {
      enum: 'PURCHASE_ORDER',
      label: 'Purchase Order',
      icon: 'ic_trolley.svg',
      activeClass: 'active',
      children: [
        {
          enum: 'LIST_PO_ALL',
          label: 'List Purchase Order',
          path: 'purchase-order/list',
          children: [],
        },
        {
          enum: 'LIST_PO_ALL',
          label: 'Sedang Menunggu',
          path: 'purchase-order/waiting',
          children: [],
        },
        {
          enum: 'LIST_PO_NEED_FULLFILL',
          label: 'Siap Diproses',
          path: 'purchase-order/needfulfill',
          children: [],
        },
        {
          enum: 'LIST_PO_DIPROSES',
          label: 'Diproses',
          path: 'purchase-order/inprogress',
          children: [],
        },
        {
          enum: 'LIST_PO_HISTORY',
          label: 'Histori',
          path: 'purchase-order/history',
          children: [],
        },
      ],
    },
  },
];
